import {
    clampOffset,
    isSectionHidden,
    normalizeSectionOrder,
    SECTION_HIDDEN_VALUE
} from '@cineamo/api/models/landing-page-editor/layout-rules';
import {
    type ElementOffset,
    type ElementOffsets,
    type ElementOffsetTarget
} from '@cineamo/api/models/premium-movie-landing-page-configuration/PremiumMovieLandingPageConfigurationDto';

export { clampOffset, isSectionHidden, normalizeSectionOrder, SECTION_HIDDEN_VALUE };

/** The page's mobile breakpoint, same as the hero's legacy `heroContentStyleListMobile`. */
export const MOBILE_MAX_WIDTH_PX = 1024;

const HERO_ELEMENT_SELECTOR: Record<ElementOffsetTarget, string> = {
    heroArtwork: '[data-hero-artwork]',
    heroButtons: '[data-hero-buttons]'
};

const toTransform = ({ dx, dy, scale = 1 }: ElementOffset): string =>
    `transform: translate(${dx}px, ${dy}px) scale(${scale})`;

/**
 * CSS applying the stored offsets to the hero's artwork and button containers. Desktop and mobile
 * are exclusive ranges, so a missing mobile offset leaves the element where the layout put it
 * rather than inheriting the desktop one.
 */
export function buildOffsetCss(offsets: ElementOffsets | undefined): string {
    if (!offsets || typeof offsets !== 'object') {
        return '';
    }
    let css = '';
    for (const target of Object.keys(HERO_ELEMENT_SELECTOR) as ElementOffsetTarget[]) {
        const selector = HERO_ELEMENT_SELECTOR[target];
        const { desktop, mobile } = offsets[target] ?? {};
        if (desktop) {
            css += `@media (min-width: ${MOBILE_MAX_WIDTH_PX + 1}px) { ${selector} { ${toTransform(clampOffset(desktop))} } } `;
        }
        if (mobile) {
            css += `@media (max-width: ${MOBILE_MAX_WIDTH_PX}px) { ${selector} { ${toTransform(clampOffset(mobile))} } } `;
        }
    }
    return css;
}
